import React from 'react';

import './style.scss';

const DecimalInput = ({
    handleChange,
    allowedDecimal = 4,
    bannedCharacters = ["e", "E", "+", "-"],
    ...rest
}) => {
    const { value } = { ...rest };

    const isNumberKey = (evt) => {
        const charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode == 46) {
        } else {
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
        }
        return true;
    };

    const handleValueChange = (e) => {
        const value = e.target.value;
        if (isNumberKey(e)) {
            handleChange(value);
        } else {
            e.preventDefault();
        }
    };

    return <React.Fragment>
        <input
            type="number"
            onChange={handleValueChange}
            onKeyDown={(evt) => bannedCharacters.includes(evt.key) && evt.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            {...rest}
        />
    </React.Fragment>;
};

export default DecimalInput;
